import axios from 'axios';
import type { StatusResponse } from '../types/status-response';
import type { GoogleDocsDTO } from './types/google-docs-dto';
import type { GoogleUploadData } from './types/google-upload-data';

export class GoogleService {
  static documentIdKey = 'document-id';

  static async upload(fileName: string, fileUrl: string): Promise<GoogleUploadData> {
    const body = new FormData();
    body.append('file_url', fileUrl);
    body.append('file_name', fileName);
    const { data } = await axios.post('/save/upload', body);
    return data;
  }

  static async save(filename: string, documentId: string, pageIndex = 1): Promise<StatusResponse> {
    const body = new FormData();
    body.append('action', 'import');
    body.append(this.documentIdKey, documentId);
    body.append('upload-file-list', filename);
    body.append('index', pageIndex.toString());
    const { data } = await axios.post('/save/document', body);
    return data;
  }

  static async saveImportLog(documentId: string): Promise<StatusResponse> {
    const body = new FormData();
    body.append('action', 'import-log');
    body.append(this.documentIdKey, documentId);
    body.append('file-src', 'drive');
    const { data } = await axios.post('/save/document', body);
    return data;
  }

  static async notifyRecipient({
    documentId,
    emailSubject,
    emailMessage,
  }: {
    documentId: string;
    emailSubject: string;
    emailMessage: string;
  }): Promise<StatusResponse> {
    const body = new FormData();
    body.append('action', 'update');
    body.append(this.documentIdKey, documentId);
    body.append('document-update-email-subject', emailSubject);
    body.append('document-update-email-message', emailMessage);
    const { data } = await axios.post('/save/board', body);
    return data;
  }

  static async updateGoogleDoc(
    documentId: string,
    editorId: string,
    editorType: string,
    title: string
  ): Promise<boolean> {
    const encodedTitle: string = encodeURIComponent(title);
    const params: string[] = [
      'action=save',
      `document-id=${documentId}`,
      `editor-id=${editorId}`,
      `title=${encodedTitle}`,
    ];
    const url = `/auth/${editorType}/?${params.join('&')}`;
    const { data } = await axios.get(url);
    return !!data.modified;
  }

  static async getDocuments(): Promise<GoogleDocsDTO[]> {
    const { data } = await axios.get('/get/template/external?createResources=true');
    if (data.error) {
      throw data.error;
    }
    return data?.templates || [];
  }
}
